import { Controller } from "@hotwired/stimulus"

const COMMANDS = {
  next: (controller) => controller.cookingModeOutlet.next(),
  back: (controller) => controller.cookingModeOutlet.prev(),
  timer: (controller, seconds) => seconds
    ? controller.cookingTimerOutlet.runFor(seconds)
    : controller.cookingTimerOutlet.toggle()
}

// Hands-free Cook Mode in the iOS app (1.3+): the app listens on-device for
// "next", "back" and "timer" (with a length, "timer 3 minutes", from 1.3.1:
// `seconds` in the detail) and sends each as recidex:voice-command; it
// reports listening on/off (or a missing permission) as recidex:voice-state.
// Browsers and older apps never see the button.
export default class extends Controller {
  static targets = ["toggle", "hint"]
  static outlets = ["cooking-mode", "cooking-timer"]

  connect() {
    this.listening = false
    this.toggleTarget.hidden = !this.voice
  }

  disconnect() {
    this.stop()
  }

  toggle() {
    this.voice?.postMessage({ action: this.listening ? "stop" : "start" })
  }

  stop() {
    if (this.listening) this.voice?.postMessage({ action: "stop" })
  }

  command({ detail: { command, seconds } }) {
    COMMANDS[command]?.(this, seconds)
  }

  state({ detail: { listening, error } }) {
    this.listening = listening
    this.toggleTarget.setAttribute("aria-pressed", String(listening))
    this.hintTarget.textContent = error === "permission"
      ? "To cook hands-free, turn on the microphone and speech recognition for Recidex in Settings."
      : "Listening. Say “next”, “back” or “timer”."
    // Visually hidden, never removed: a status region VoiceOver can already
    // see is the one it reads aloud when its text changes.
    this.hintTarget.classList.toggle("sr-only", !listening && !error)
  }

  get voice() {
    return window.webkit?.messageHandlers?.cookVoice
  }
}
